<div class="home container-fluid">
  <div class="row">
    <div class="col-md-12 p-0">
      <ng-container *ngIf="!isDiscover">
        <arsultima-carousel
          [slides]="slides"
          [isEditable]="isEditable"
          [page]="page"
        ></arsultima-carousel>
      </ng-container>

      <ng-container *ngIf="isDiscover">
        <arsultima-slide-subheader
          [id]="discoverSlide?.ID"
          [imageUrl]="imageUrl"
          [isEditable]="isEditable"
          [copyright]="discoverSlide?.copyright"
          [page]="page"
        ></arsultima-slide-subheader>
      </ng-container>
    </div>
  </div>
  <!-- <div class="row" *ngIf="isArsultimaHomePage()">
    <div class="col-m-12 d-flex pt-4 cards">
      <arsultima-home-cards [cards]="homeCards"></arsultima-home-cards>
    </div>
  </div> -->
  <div *ngFor="let block of blocks">
    <arsultima-block [block]="block" [isEditable]="isEditable" [page]="page"></arsultima-block>
  </div>
  <div class="row mt-4 pb-4" *ngIf="notMoreThanMaxBlock && isEditable">
    <div class="col-md-12 d-flex justify-content-center">
      <button mat-stroked-button class="button" (click)="addBlock()">
        {{ 'home.newBlock' | transloco }}
      </button>
    </div>
  </div>
</div>
<arsultima-scroll-indicator></arsultima-scroll-indicator>
